<template>
  <div class="animated fadeIn overflow-auto">
    <div class="pre-scrollable  " style="max-height: 85vh; overflow-x: hidden;">
      <b-navbar :no-body="true" class="p-0 " fixed :sticky="true" toggleable="lg" type="light" :variant="isDark ? 'dark' : 'light'">
        <b-navbar-brand>
            <i class="fa fa-address-book-o bg-info p-3 font-2xl mr-3 float-left "></i>
            <div class="h5 mb-0 mt-2" :class="isDark ? 'text-light' : 'text-muted'"  style="padding-right: 150px !important;">
              Cadastro de Departamento
            </div>
            <div class="text-uppercase font-weight-bold font-xs" :class="isDark ? 'text-light' : 'text-muted'" >
              DEPARTAMENTO: {{registro.ID}} <span v-if="registro.ID > 0 ">-</span> {{registro.NOME ? registro.NOME.substring(0,22) : ""}}
            </div>
        </b-navbar-brand>
        
         
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button size="lg" variant="outline-info" class="px-3 font-weight-bold" type="button" @click.stop.prevent="voltar()" > 
                   <i class="fa fa-arrow-left"></i>  Voltar
              </b-button>
              <b-button size="lg" class="px-4 font-weight-bold" variant="success" type="button" @click.stop.prevent="postOrEdit()" > 
                  <i class="fa fa-save"></i>  Gravar
              </b-button> 
            </b-nav-form>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <b-row class="align-stretch">
        <b-col sm="9" class="d-flex pr-0">

          <b-card  class="w-100 h-100" :bg-variant="isDark ? 'gray-700' : 'light'">
            <div slot="header">
              <strong>  Identificação</strong>
            </div>
            
            <b-row>
              <!--/.col-->
              <b-col sm="2">
                <b-form-fieldset label="Código">
                  <b-form-input type="text" id="ID" :disabled="true" placeholder="Código Automático" v-model="registro.ID"></b-form-input>
                </b-form-fieldset>
              </b-col>
              
            </b-row> 
            <b-row >
              <!--/.col-->
              <b-col sm="8">
                <b-form-fieldset label="Nome">
                  <b-form-input type="text" id="edNOME" ref="edNOME" :disabled="false" 
                  placeholder="Informe o Nome min(3 letras)"
                  v-model="registro.NOME"
                  :state="!!registro.NOME"> </b-form-input>
                </b-form-fieldset>
              </b-col>  
              <!--/.col-->
              <b-col sm="4">
                <b-form-fieldset label="Responsvel">
                  <b-form-input type="text" id="edRESPONSAVEL" ref="edRESPONSAVEL" :disabled="false" 
                  placeholder="Informe o Responsável min(3 letras)" 
                  v-model="registro.RESPONSAVEL"
                  :state="!!registro.RESPONSAVEL"> </b-form-input>
                </b-form-fieldset>
              </b-col>  
            </b-row>  
            <b-row>
              <b-col sm="2">
                <b-form-fieldset label="Tipo de Bem">
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.TIPO" 
                        :state="!!registro.TIPO"
                        :options="optionsTIPO">
                  </b-form-select>
                </b-form-fieldset>
              </b-col>
             
            </b-row>    
           
              
          </b-card>
        </b-col>
        
        <b-col sm="3" class="d-flex pl-0">
          <b-card  class="w-100 h-100" :bg-variant="isDark ? 'gray-700' : 'light'">
            <div slot="header">
              <strong>Opções</strong>
            </div>
            <b-row>
              <b-col sm="6">
                <b-form-checkbox
                    id="checkbox-1"
                    v-model="registro.SITUACAO"
                    name="checkbox-1"
                    value="1"
                    unchecked-value="0">
                    Ativo
                </b-form-checkbox>
              </b-col>
            </b-row>


            
              
          </b-card>
        </b-col>
      </b-row>
      
    </div>
    
  </div>
</template>

<script>

import Tools from '@/tools/tools.js'
import moment from 'moment'

export default {
  components: {

  },
  data () {
    return {
      desabilitado: true,
      formatoQuantidade: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimal: ',',
        precision: 3
      },
      formatoPecas: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimalPlaces: '0',
        roundingMethod: 'U',
        minimumValue: '0'
      },
      formatoPercentual: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimalPlaces: '3',
        roundingMethod: 'U',
        minimumValue: 0,
        maximumValue: 100,
        suffixText: ' %',
        modifyValueOnWheel: false
        
      },
      formatoMoeda: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimalPlaces: '2',
        roundingMethod: 'U',
        minimumValue: 0,
        prefix: 'R$: ',
        modifyValueOnWheel: false
        
      },
      optionsTIPO: [
        { value: null, text: 'Selecione' },
        { value: 'I', text: 'Interno' },
        { value: 'E', text: 'Externo' }
      ],
      registro: {
        ID                 : null,
        DT_CADASTRO        : null,
        DT_ALTERACAO       : null,
        USUARIO_CADASTRO   : null,
        USUARIO_ALTERACAO  : null,
        NOME               : null,
        RESPONSAVEL        : null,
        SITUACAO           : null,
        OBSERVACAO         : null,
        TIPO               : null,
        CENTRO_CUSTO_ID    : null,
      },
    }
  },
  
  methods: {
    voltar() {
      this.$router.push('/almoxarifado/departamento/index')
    },
    async postOrEdit () {
      if (this.avisos()) return
      
      try {
        this.$store.commit('controle/setAguardando', true)  
        if (!this.registro.ID) {
          
          try {  
            const postPayload = {
              registro: this.registro,
              login: window.localStorage.getItem('login')
            }

            const { data } = await this.$http.post(`/api/protected/departamento/post`, postPayload)
            
            if (!data || !data.registro) {
              Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Não foi possível cadastrar!' )  
              return
            }
            
            this.registro = {...data.registro[0]}
            this.$store.commit("departamento/SET_LIMPAR", null)
            this.$store.commit("departamento/SET_REGISTRO_SELECIONADO_ID", this.registro.ID)
            this.$store.commit("departamento/SET_ID", this.registro.ID)
            this.$store.commit('departamento/SET_PAGINA_ATUAL', 1)
            await this.$store.dispatch('departamento/GET_LISTA')
            this.$store.commit("departamento/SET_LIMPAR_APENAS_FILTRO", null) // limpar o filtro pq ja localizou o registro novo 

            this.$store.commit('controle/setAguardando', false)  

            const msg = await this.$bvModal.msgBoxConfirm('Cadastrado com Sucesso. Continuar Cadastrando?', {
              title: 'Sucesso',
              size: 'sm',
              buttonSize: 'xl',
              okVariant: 'success',
              okTitle: 'SIM',
              cancelTitle: 'NÃO',
              footerClass: 'p-2',
              hideHeaderClose: false,
              centered: true,
              noCloseOnEsc: true, 
              noCloseOnBackdrop: true
            })
            
            if (msg == true) return

            this.$router.push('/almoxarifado/departamento/index')

          } catch(err) {
            console.log(err)
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Não foi possível gravar as informações' )
            return
          }

        } else {
          try {        
            const editPayload = {
              registro: this.registro,
              login: window.localStorage.getItem('login'),
              operacao: this.emAlteracao == true ? 'alt' : 'inc' //necessario para o backend entender se o form inicio como novo ou iniciou como edicao
            }
            let { data } = await this.$http.post(`/api/protected/departamento/edit`, editPayload)
            this.registro = (data?.registro) ?? null

            this.$store.commit('controle/setAguardando', false)  

            this.$router.push('/almoxarifado/departamento/index')

          } catch(err) {
            console.log(err)
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Não foi possível gravar os dados solicitados' )
            return
          }

          
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)  
      }
    },
    limparRegistro () {
      Tools.resetToNull(this.registro, true)  
    },
    
    
    avisos() {
      if (!this.registro.NOME) {
        this.$refs.edNOME.$refs.input.focus()
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Nome')
        return true
      }
      return false
      
    }
    
  },
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  }
    
  },
  async created () {
    const id = this.$route.params.id ? Number(this.$route.params.id) : null

    try {
      
      if ( id ) {
        this.emAlteracao = true
        const { data: result } = await this.$http.get(`/api/protected/departamento/getById/${id}`)
        if (!Array.isArray(result) || result.length === 0) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Cadastro não localizado.')
          this.$router.replace('/almoxarifado/departamento/index')
          return
        }
        
        this.registro = { ...result[0] }
      } else {
        this.emAlteracao = false
        await this.limparRegistro()
      }
    } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        this.$router.replace('/almoxarifado/departamento/index') 
    } finally {
      this.$store.commit('controle/setAguardando', false)  
    }
  },
  mounted (){
    this.$nextTick(() => {
      if (!this.$route.params.id) {
        // tenta API do componente; se não, foca no input interno
        const c = this.$refs.edNOME
        if (c?.focus) c.focus()
        else c?.$el?.querySelector('input')?.focus()
      }
    })
  },
  watch: {
    
  }
}
</script>
<style lang="css" scoped>
.prepend-160 {
  flex: 0 0 130px;   /* fixa a coluna */
  width: 130px;      /* redundante, mas ajuda em alguns temas */
  min-width: 130px;  /* garante que não encolha */
}
</style>




// WEBPACK FOOTER //
// src/views/almoxarifado/departamento/DepartamentoCadastro.vue